import { useEffect, useState } from 'react';

/**
 * Whether the viewport is at least `px` wide, kept in sync on resize.
 *
 * Read on the first render (not in an effect) so the shell does not flash its
 * desktop layout on a narrow window. Without `matchMedia` (jsdom) it answers
 * true: the desktop layout is the default the tests are written against.
 */
export function useMinWidth(px: number): boolean {
  const query = `(min-width: ${px}px)`;
  const [matches, setMatches] = useState(() =>
    typeof window === 'undefined' || typeof window.matchMedia !== 'function'
      ? true
      : window.matchMedia(query).matches
  );

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const list = window.matchMedia(query);
    const onChange = () => setMatches(list.matches);
    onChange();
    list.addEventListener('change', onChange);
    return () => list.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
